module.exports = __webpack_public_path__ + "img/mail_w.e96a30fd.svg";